import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
}), 'DoneTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/DoneTwoTone.js
// module id = 3247
// module chunks = 2